import { jsx as _jsx } from "react/jsx-runtime";
import { TLIcon } from './TLIconRegistry';
// ─── Helper: build an icon function from a registry key ─────────
function iconFn(name) {
    return (color = '#555', size = 24) => _jsx(TLIcon, { name: name, color: color, size: size });
}
// ─── AMENITY TYPE ICONS ─────────────────────────────────────────
export const AmenityIcons = {
    // v2 Core Amenity icons
    elevator: iconFn('elevator'),
    stairs: iconFn('stairs'),
    restroom: iconFn('restroom'),
    parking: iconFn('parking'),
    wifi: iconFn('wifi'),
    fire_extinguisher: iconFn('fire_extinguisher'),
    security_camera: iconFn('security_camera'),
    air_conditioning: iconFn('air_conditioning'),
    wheelchair_access: iconFn('wheelchair_access'),
    power_outlet: iconFn('power_outlet'),
    first_aid: iconFn('first_aid'),
    pet_friendly: iconFn('pet_friendly'),
    ev_charging: iconFn('ev_charging'),
    bike_storage: iconFn('bike_storage'),
    storage_room: iconFn('storage_room'),
    server_room: iconFn('server_room'),
    chapel: iconFn('chapel'),
    smoking_area: iconFn('smoking_area'),
    vending: iconFn('vending'),
    water_fountain: iconFn('water_fountain'),
    changing_room: iconFn('changing_room'),
    rooftop: iconFn('rooftop'),
    garden: iconFn('garden'),
    loading_dock: iconFn('loading_dock'),
    stairwell: iconFn('stairs'),
    // Legacy icons (from v1)
    washroom: iconFn('legacy_washroom'),
    kitchen: iconFn('legacy_kitchen'),
    break_room: iconFn('legacy_break_room'),
    meeting_room: iconFn('legacy_meeting_room'),
    lounge: iconFn('legacy_lounge'),
    lobby: iconFn('legacy_lobby'),
    gym: iconFn('legacy_gym'),
    cafeteria: iconFn('legacy_cafeteria'),
    outdoor: iconFn('legacy_outdoor'),
    reception: iconFn('legacy_reception'),
    default: iconFn('legacy_default_amenity'),
    // Aliases
    bathroom: iconFn('legacy_washroom'),
    pantry: iconFn('legacy_kitchen'),
    conference_room: iconFn('legacy_meeting_room'),
    fitness: iconFn('legacy_gym'),
};
// ─── ISSUE TYPE ICONS ───────────────────────────────────────────
export const IssueIcons = {
    // v2 Core Issue icons
    broken_light: iconFn('broken_light'),
    water_damage: iconFn('water_damage'),
    broken_lock: iconFn('broken_lock'),
    noise: iconFn('noise'),
    temperature: iconFn('temperature'),
    odor: iconFn('odor'),
    elevator_stuck: iconFn('elevator_stuck'),
    slip_hazard: iconFn('slip_hazard'),
    vandalism: iconFn('vandalism'),
    clogged: iconFn('clogged'),
    graffiti: iconFn('graffiti'),
    leak: iconFn('leak'),
    mold: iconFn('mold'),
    crack: iconFn('crack'),
    pest: iconFn('pest'),
    blocked_drain: iconFn('blocked_drain'),
    power_outage: iconFn('power_outage'),
    structural: iconFn('structural'),
    // Legacy icons (from v1)
    dirty: iconFn('legacy_dirty'),
    broken: iconFn('legacy_broken'),
    supplies: iconFn('legacy_supplies'),
    smell: iconFn('legacy_smell'),
    spill: iconFn('legacy_spill'),
    lighting: iconFn('legacy_lighting'),
    safety: iconFn('legacy_safety'),
    other: iconFn('legacy_other'),
    default: iconFn('legacy_other'),
    // Aliases
    cleanliness: iconFn('legacy_dirty'),
    maintenance: iconFn('legacy_broken'),
    no_supplies: iconFn('legacy_supplies'),
    wet: iconFn('legacy_spill'),
};
// ─── RATING ICONS ───────────────────────────────────────────────
export const RatingIcons = {
    1: iconFn('rating_face_1'),
    2: iconFn('rating_face_2'),
    3: iconFn('rating_face_3'),
    4: iconFn('rating_face_4'),
    5: iconFn('rating_face_5'),
};
// ─── RATING COLORS ──────────────────────────────────────────────
export const RATING_ICON_COLORS = {
    1: '#C44536',
    2: '#C44536',
    3: '#B8860B',
    4: '#2D6A4F',
    5: '#2D6A4F',
};
const CONTAINER_SIZES = {
    sm: { width: 32, height: 32, borderRadius: 8 },
    md: { width: 44, height: 44, borderRadius: 10 },
};
export function IconContainer({ children, size = 'md', className }) {
    const s = CONTAINER_SIZES[size];
    return (_jsx("div", { className: className, style: {
            width: s.width,
            height: s.height,
            borderRadius: s.borderRadius,
            background: '#F5F3EF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
        }, children: children }));
}
// ─── HELPER: get amenity icon by type name ──────────────────────
export function getAmenityIcon(typeName, color = '#555', size = 22) {
    const key = typeName.toLowerCase().replace(/[\s-]+/g, '_');
    const iconFn = AmenityIcons[key] ?? AmenityIcons.default;
    return iconFn(color, size);
}
// ─── HELPER: get issue icon by type name ────────────────────────
export function getIssueIcon(typeName, color = '#555', size = 22) {
    const key = typeName.toLowerCase().replace(/[\s-]+/g, '_');
    const iconFn = IssueIcons[key] ?? IssueIcons.default;
    return iconFn(color, size);
}
// ─── HELPER: get rating icon ────────────────────────────────────
export function getRatingIcon(rating, size = 28) {
    const clamped = Math.max(1, Math.min(5, Math.round(rating)));
    const color = RATING_ICON_COLORS[clamped];
    return RatingIcons[clamped](color, size);
}
//# sourceMappingURL=TendedLoopIcons.js.map